import { START, END, ERROR, CANCEL } from '@/state/types/fetch'
import { LOGIN_LOADING, LOGIN_SUCCESS, LOGIN_FAILURE } from '@/state/types/auth'

export default (previousState = 0, { type }) => {
  switch (type) {
    case START:
    case LOGIN_LOADING:
      return previousState + 1
    case END:
    case ERROR:
    case CANCEL:
    case LOGIN_SUCCESS:
    case LOGIN_FAILURE:
      return Math.max(previousState - 1, 0)
    default:
      return previousState
  }
}



// WEBPACK FOOTER //
// ./state/reducers/loading.js